import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56f90051"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = { class: "banan" }
const _hoisted_5 = { class: "items" }
const _hoisted_6 = {
  key: 0,
  class: "box"
}
const _hoisted_7 = { class: "img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "btns" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = { class: "tag" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 支持")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = {
  key: 1,
  class: "line"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  key: 1,
  class: "box"
}
const _hoisted_20 = { class: "info" }
const _hoisted_21 = { class: "btns" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = { class: "tag" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode()
const _hoisted_26 = {
  key: 1,
  class: "line"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode()
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "img" }
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagination" }, null, -1))
const _hoisted_32 = { class: "boxs" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "试用软件正在准备中，敬请期待！", -1))

import {reactive, onMounted , watch ,ref} from "vue";
import Nav from '@/components/nav/Index.vue';
import Tab from '@/components/produTab/Index.vue';
import { useRouter , useRoute } from "vue-router";
 import { getNwes } from "@/api/backstage";
import { ElMessage, ElMessageBox } from 'element-plus';
import { getSelectSample } from "@/api/index";
import bg1 from '@/assets/website/supbg1.jpg';
import bg2 from '@/assets/website/supbg2.jpg';
import bg3 from '@/assets/website/supbg3.jpg';

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props


let types = ref('PRODUCT_EDUCATION');
const mb: any =ref('');
 watch(
  () => props.isMobile,
  (newv, oldv) => {
       props.isMobile? mb.value = true : mb.value = false;    
  }
);
const acrRef: any = ref(null);
const bgs = [bg1,bg2,bg3];
const router = useRouter();
const route = useRoute();
 
const datas: any = reactive({
  vzb:false,
  product:[],
  productAll:'',
  banner:'',
  filurl:localStorage.getItem('fileUrel'),
  total:0,
  items:[],
  tops:[],
  topform:{
    isTop:1,
    status:'STATUS_YES',
    newsType:'NEWS_NOTICE',
  },
  form: {
    newsType: "NEWS_NOTICE",
    pageNum: 1,
    pageSize: 4,
    isTop:0,
    status:'STATUS_YES',
  },
});

 


const getData = () =>{
  getSelectSample().then((res: any) =>{
    datas.productAll = res.data;
    datas.product =  datas.productAll['PRODUCT_EDUCATION'];
    for(let i=0; i< datas.product.length; i++){
      datas.product[i].bg = bgs[i];
    }
  });
};


 
 const onChecked = (val: any) => {
    datas.product= [];
    datas.product = JSON.parse(JSON.stringify(datas.productAll[val])) ;
    for(let i=0; i< datas.product.length; i++){
      datas.product[i].bg = bgs[i];
    }
  };

 


const getBanner = (banner: any) => {
 datas.banner = banner;
};


const down = () => {
 datas.vzb=true;
};

const getNews = () =>{
  getNwes(datas.form).then((res: any) =>{
      for(const item of res.data.list){
      if(item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
    }
    datas.items = res.data.list;
    datas.total = res.data.total;
  });
};

const open = (url: any) => {
   router.push(url);
};
const getTop = () =>{
  getNwes(datas.topform).then((res: any) =>{
    for(const item of res.data.list){
      if(item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
    }
    console.log( datas.tops);
    
    datas.tops = res.data.list;
    setTimeout(()=>{
      acrRef.value?.setActiveItem(0);
      },100);
  });
};

onMounted(() => {
  getData();
  getTop();
  getNews();
  mb.value =props.isMobile;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value?'Mobile':'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        style: 'w',
        isMobile: mb.value,
        onGetBanner: getBanner
      }, null, 8, ["isMobile"]),
      (datas.banner.length==1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: datas.filurl+datas.banner[0].fileName,
            alt: ""
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (datas.banner.length==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(datas.banner[0].title), 1),
            _createElementVNode("p", null, _toDisplayString(datas.banner[0].description), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Tab, { onOnChecked: onChecked }),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.product, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", index%2==0?'s1':'s2']),
          key: index,
          style: _normalizeStyle({background:`url(${item.bg}) 100%`})
        }, [
          (index%2==0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: datas.filurl+item.trialCoverName,
                    alt: ""
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                  _createElementVNode("p", null, _toDisplayString(item.description), 1),
                  _createElementVNode("ul", _hoisted_10, [
                    (item.pcFileName)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          onClick: down
                        }, "PC下载"))
                      : _createCommentVNode("", true),
                    _hoisted_11,
                    (item.appFileName)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 1,
                          onClick: down
                        }, "APP下载"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    (item.pcFileName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, " PC "))
                      : _createCommentVNode("", true),
                    _hoisted_15,
                    (item.pcFileName&&item.appFileName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "|"))
                      : _createCommentVNode("", true),
                    _hoisted_17,
                    (item.appFileName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Android平台"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (index%2==1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                  _createElementVNode("p", null, _toDisplayString(item.description), 1),
                  _createElementVNode("ul", _hoisted_21, [
                    (item.pcFileName)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          onClick: down
                        }, "PC下载"))
                      : _createCommentVNode("", true),
                    _hoisted_22,
                    (item.appFileName)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 1,
                          onClick: down
                        }, "APP下载"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    (item.pcFileName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, " 支持 PC "))
                      : _createCommentVNode("", true),
                    _hoisted_25,
                    (item.pcFileName&&item.appFileName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, "|"))
                      : _createCommentVNode("", true),
                    _hoisted_27,
                    (item.appFileName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, " Android平台"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("img", {
                    src: datas.filurl+item.trialCoverName,
                    alt: ""
                  }, null, 8, _hoisted_30)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 6))
      }), 128))
    ]),
    _hoisted_31,
    (datas.vzb)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dal",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (datas.vzb= false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (datas.vzb= false))
            }, "确定")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})